import { render, staticRenderFns } from "./EfsFeeCategoryDictList.vue?vue&type=template&id=45d243d8&scoped=true&"
import script from "./EfsFeeCategoryDictList.vue?vue&type=script&lang=js&"
export * from "./EfsFeeCategoryDictList.vue?vue&type=script&lang=js&"
import style0 from "./EfsFeeCategoryDictList.vue?vue&type=style&index=0&id=45d243d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d243d8",
  null
  
)

export default component.exports